/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/forbid-prop-types */
import React from 'react';
import Tree from 'react-virtualized-tree/lib/TreeContainer';
import Expandable from 'react-virtualized-tree/lib/renderers/Expandable';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import RemoveCircleIcon from '@material-ui/icons/RemoveCircle';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import Checkbox from '@material-ui/core/Checkbox';
import Divider from '@material-ui/core/Divider';
import PropTypes from 'prop-types';

const LeftSide = (props) => {
  const { data } = props;
  const {
    handleToggleAll,
    numberOfChecked,
    handleToggle,
    changeTree,
    left,
    categorie,
    checked,
    classes,
  } = data;
  return (
    <Card style={{ height: '800px' }}>
      <CardHeader
        className={classes.cardHeader}
        avatar={(
          <Checkbox
            onClick={handleToggleAll(left)}
            checked={numberOfChecked(left) === left.length && left.length !== 0}
            indeterminate={numberOfChecked(left) !== left.length && numberOfChecked(left) !== 0}
            disabled={left.length === 0}
            inputProps={{ 'aria-label': 'all items selected' }}
          />
          )}
        title="Ressources disponibles"
        subheader={`${numberOfChecked(left)}/${left.length} selected`}
      />
      <Divider />
      <Tree nodes={categorie} onChange={() => ({})}>
        {({ style, node, ...rest }) => {
          if (!node.id.includes('cat-')) {
            return (
              <div style={style}>
                <Expandable node={node} {...rest}>
                  <ListItem key={node.id} role="listitem" button onClick={handleToggle(node.id)}>
                    <ListItemIcon>
                      <Checkbox
                        name={`CoursplanList-${node.id}`}
                        checked={checked.indexOf(node.id) !== -1}
                        tabIndex={-1}
                        disableRipple
                        inputProps={{ 'aria-labelledby': node.id }}
                      />
                    </ListItemIcon>
                    <ListItemText id={node.id} primary={`${node.name}`} />
                  </ListItem>
                </Expandable>
              </div>
            );
          }

          const newstyle = { ...style };
          newstyle.backgroundColor = '#F5F5F5';
          const index = parseInt(node.id.replace(/\D/g, ''), 10);

          return (
            <div style={newstyle} onClick={() => changeTree(node.id)}>
              <Expandable node={node} {...rest}>
                <ListItem key={node.id} role="listitem">
                  <ListItemIcon>
                    {categorie[index] && categorie[index].state.expanded
                      ? <RemoveCircleIcon /> : <AddCircleIcon />}
                  </ListItemIcon>
                  <ListItemText id={node.id} primary={<Typography type="body2" style={{ fontWeight: 'bold', color: '#000' }}>{node.name}</Typography>} />
                </ListItem>
              </Expandable>
            </div>
          );
        }}
      </Tree>
    </Card>
  );
};

LeftSide.propTypes = {
  data: PropTypes.any.isRequired,
};

export default LeftSide;
